/**
 * Maps survey categories to their prescreen verification statement.
 * Must match the backend SURVEY_CATEGORY_TARGETING keys.
 */
export const PRESCREEN_STATEMENTS: Record<string, string> = {
  Lifestyle: 'You own a pet dog or cat',
  'Home & Garden': 'You own or rent your home',
  Technology: 'You use a smartphone or computer daily',
  Finance: 'You have a bank account or investment account',
  Health: 'You are interested in health and wellness',
  'Food & Dining': 'You dine out or order food delivery regularly',
  Travel: 'You have traveled in the past 12 months',
  Shopping: 'You shop online at least once a month',
};
